$(document).ready(function () {

  const $addButton = $("#btn-add-object-lease-type");
  const $tableBody = $("#object-lease-type");

  function checkRowLimit() {
    const rowCount = $tableBody.find("tr").length;
    $addButton.prop("disabled", rowCount >= 100);
  }
  checkRowLimit();

  if ($("#object-lease-type tr input[type='text']").length === 0) {
    $(".btn-submit-object-lease-type").addClass("hidden")
    $(".btn-edit-object-lease-type").removeClass("hidden")
  }else{
    $('.btn-submit-object-lease-type').removeClass('hidden')
    $('.btn-edit-object-lease-type').addClass('hidden')
  }

  //add row
  $addButton.on("click", function () {
    checkRowLimit();

    $('.btn-submit-object-lease-type').removeClass('hidden')
    $('.btn-edit-object-lease-type').addClass('hidden')

    const newRow = `
                    <tr>
                      <td class="order">
                        <input name="object_lease_types[][order]" class="form-control order convert-half-width" min="1" />
                      </td>
                      <td class="name">
                        <input type="text" name="object_lease_types[][name]" class="form-control name" />
                      </td>
                      <td class="text-center is-hidden">
                        <input type="checkbox" name="object_lease_types[][is_hidden]" class="form-check-input is-hidden" value="1" style="margin-left: 23px; margin-top: 8px;"/>
                        <button type="button" class="btn btn-sm btn-danger remove-row"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  `;
    $("#object-lease-type").append(newRow);
  });

  //Remove row
  $("#object-lease-type").on("click", ".remove-row", function () {
    $(this).closest("tr").remove();

    if ($("#object-lease-type tr input[type='text']").length === 0) {
      $(".btn-submit-object-lease-type").addClass("hidden")
      $(".btn-edit-object-lease-type").removeClass("hidden")
    }
  });

  //Toggle show/hide
  $("#showHidden").on("change", function () {
    if ($(this).is(":checked")) {
      $(".is-hidden input:checked").closest("tr").show()
    } else {
      $(".is-hidden input:checked").closest("tr").hide()
    }
  })


  $(document).on('change', 'input[name="show_acceptance"]', function() {
    const selectedValue = $(this).val();

    const $acceptanceDate = $('.acceptance-date-filter');

    const $clearIcon = $acceptanceDate.siblings('.clear-icon');
    const $acceptanceGteq = $('input[name="q[acceptance_date_gteq]"]');
    const $acceptanceLteq = $('input[name="q[acceptance_date_lteq]"]');

    if (selectedValue === 'exist') {
      $acceptanceDate.show();
      $clearIcon.removeClass('d-none');
    } else {
      $acceptanceDate.val('').hide();
      $acceptanceGteq.val('');
      $acceptanceLteq.val('');
      $clearIcon.addClass('d-none');
    }
  });
  $('input[name="show_acceptance"]:checked').trigger('change');

  $(document).on('change', '#check-all-checkbox', function () {
    const isChecked = $(this).is(':checked');

    $('.item-checkbox').each(function () {
      const $checkbox = $(this);

      if (!$checkbox.prop('disabled')) {
        $checkbox.prop('checked', isChecked);
      }
    });
  });

});
